import { Route, Routes,Navigate } from "react-router-dom";
import Login_1 from "./sections/login/personal/login_1/login/login";
import Login_2 from "./sections/login/personal/login_2/login/login";
import Login_3 from "./sections/other-apps/Login";
import Login_4 from "./sections/other-apps/check-user";
import EmailAddress from "./sections/email-address/email-address";
import ForgotPassword from "./sections/forgot-password/forgot-password";
import VerifyPhoneNumber from "./sections/verify-phone-number/verify-phone-number";
import SelectAccount from "./sections/select-account/select-account";

// create account / personal / registration screen ui
import Register from "./sections/create-account/personal/registration-screen-ui/registration-screen-ui_1/register";
import PersonalDetails from "./sections/create-account/personal/registration-screen-ui/registration-screen-ui_2/personal-details/personal-details";
import ChooseMail from "./sections/create-account/personal/registration-screen-ui/registration-screen-ui_3/choose-mail/choose-mail";
import CreatePassword from "./sections/create-account/personal/registration-screen-ui/registration-screen-ui_4/create-password/create-password";
import CAPTCHA from "./sections/create-account/personal/registration-screen-ui/registration-screen-ui_5/captcha/captcha";
import EnterCode from "./sections/create-account/personal/registration-screen-ui/registration-screen-ui_6/enter-code/enter-code";
import RecoveryMail from "./sections/create-account/personal/registration-screen-ui/registration-screen-ui_7/recovery-mail/recovery-mail";
import ReviewInfo from "./sections/create-account/personal/registration-screen-ui/registration-screen-ui_8/review-info/review-info";
/* ==================================== */

// create account / personal / registration screen ui
import RegisterBusiness from "./sections/create-account/business/business-screen-ui/business-screen-ui_1/register";
import NumberOfEmployee from "./sections/create-account/business/business-screen-ui/business-screen-ui_2/number-of-emloyee";
import ContactInfo from "./sections/create-account/business/business-screen-ui/business-screen-ui_3/contact-info";
import Domain from "./sections/create-account/business/business-screen-ui/business-screen-ui_4/domain";
import DomainYes from "./sections/create-account/business/business-screen-ui/business-screen-ui_5/domain-yes";
import DomainNoFind from "./sections/create-account/business/business-screen-ui/business-screen-ui_5/domain-no-find";
import DomainNoAvailable from "./sections/create-account/business/business-screen-ui/business-screen-ui_5/domain-no-available";
import BusinessInformation from "./sections/create-account/business/business-screen-ui/business-screen-ui_6/business-information";
import BusinessContactInfo from "./sections/create-account/business/business-screen-ui/business-screen-ui_7/business-contact-info";
import SingInDetails from "./sections/create-account/business/business-screen-ui/business-screen-ui_8/sign-in-details";
import CaptchaBusiness from "./sections/create-account/business/business-screen-ui/business-screen-ui_10/captcha-business";
/* ==================================== */

/* forget mail email / personal / email recovery */
import ForgotMail_email from "./sections/forget-email/personal/email-recovery/email-recovery_1/forgot-mail-email/forgot-mail-email";
import FullName_email from "./sections/forget-email/personal/email-recovery/email-recovery_2/full-name-email/full-name-email";
import VerificationCode_email from "./sections/forget-email/personal/email-recovery/email-recovery_3/verification-code-email/verification-code-email";
import EnterCodeEmailRecovery_email from "./sections/forget-email/personal/email-recovery/email-recovery_4/enter-code-email/enter-code-email";
import SelectAccount_email from "./sections/forget-email/personal/email-recovery/email-recovery_5/select-account-email/select-account-email";
/* ==================================== */

/* forget mail phone / personal / email recovery */
import ForgotMail_phone from "./sections/forget-email/personal/phone-recovery/phone-recovery_1/forget-mail-phone/forget-mail-phone";
import FullName_phone from "./sections/forget-email/personal/phone-recovery/phone-recovery_2/full-name-phone/full-name-phone";
import VerificationCode_phone from "./sections/forget-email/personal/phone-recovery/phone-recovery_3/verification-code-phone/verification-code-phone";
import EnterCodeEmailRecovery_phone from "./sections/forget-email/personal/phone-recovery/phone-recovery_4/enter-code-phone/enter-code-phone";
import SelectAccountSignIn_phone from "./sections/forget-email/personal/phone-recovery/phone-recovery_5/select-account-phone/select-account-phone";
/* ==================================== */

/* forget password mailApp / personal / password recovery */
import ForgotPassword1_mailApp from "./sections/forget-password/personal/password-recovery/password-recovery_1/forgot-password-email/forgot-password-email";
import ForgotPassword2_mailApp from "./sections/forget-password/personal/password-recovery/password-recovery_2/forgot-password-email/forgot-password-email";

/* ==================================== */

/* forget password phone / personal / password recovery */
import ForgotPasswordPhone_1 from "./sections/forget-password/personal/phone-password-recovery/phone-password_1/forgot-password-phone_1/forgot-password-phone_1";
import ForgotPasswordPhone_2 from "./sections/forget-password/personal/phone-password-recovery/phone-password_2/forgot-password-phone_2/forgot-password-phone_2";
import ForgotPasswordPhone_3 from "./sections/forget-password/personal/phone-password-recovery/phone-password_3/forgot-password-phone_3/forgot-password-phone_3";
/* ==================================== */

/* forget password email / personal / password recovery */
import ForgotPasswordEmail_1 from "./sections/forget-password/personal/web-password-recovery/web-password_1/forgot-password-email_1/forgot-password-email_1";
import ForgotPasswordEmail_2 from "./sections/forget-password/personal/web-password-recovery/web-password_2/forgot-password-email_2/forgot-password-email_2";
/* ==================================== */

import { createTheme } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import AuthorizationProvider from "./hooks/Authorize";
import Logout from "./sections/logout/logout";
import BusinessEnterCode from "./sections/create-account/business/business-screen-ui/business-screen-ui_9/business-enter-code";
import { GatewayStateProvider } from "./gateway/GatewayStateMachine";
import GatewayLegacyStep from "./gateway/GatewayLegacyStep";
import SecurityVerification from "./sections/security-verification/security-verification";
import SecurityEnrollment from "./sections/security-enrollment/security-enrollment";
import SecurityCenter from "./sections/security-center/security-center";
import { MotionProvider, AuthMotionScene } from "./motion/CinematicAuthMotion";


function App() {

  const theme = createTheme({
    palette: {
      mode: "dark",
    },
  });


  return (
    <MotionProvider>
      <AuthMotionScene>
    <GatewayStateProvider>
    <AuthorizationProvider >
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login_1 />} />
        <Route path="/login_2" element={<Login_2 />} />
        <Route path="/security-verification" element={<SecurityVerification />} />
        <Route path="/security-enrollment" element={<SecurityEnrollment />} />
        <Route path="/security-center" element={<SecurityCenter />} />
        <Route path="/other-apps" element={<Login_3 />} />
        <Route path="/check-user" element={<Login_4 />} />
        <Route path="/email-address" element={<GatewayLegacyStep stage="recovery"><EmailAddress /></GatewayLegacyStep>} />
        <Route path="/forgot-password" element={<GatewayLegacyStep stage="recovery"><ForgotPassword /></GatewayLegacyStep>} />
        <Route path="/verify-phone-number" element={<GatewayLegacyStep stage="recovery"><VerifyPhoneNumber /></GatewayLegacyStep>} />
        <Route path="/select-account" element={<GatewayLegacyStep stage="recovery"><SelectAccount /></GatewayLegacyStep>} />

        {/* // create account / personal / registration screen ui */}
        <Route path="/signup" element={<Register />} />
        <Route path="/register" element={<Register />} />
        <Route path="/personal-details" element={<GatewayLegacyStep stage="registration"><PersonalDetails /></GatewayLegacyStep>} />
        <Route path="/choose-mail" element={<GatewayLegacyStep stage="registration"><ChooseMail /></GatewayLegacyStep>} />
        <Route path="/create-password" element={<GatewayLegacyStep stage="registration"><CreatePassword /></GatewayLegacyStep>} />
        <Route path="/captcha" element={<GatewayLegacyStep stage="registration"><CAPTCHA /></GatewayLegacyStep>} />
        <Route path="/enter-code" element={<GatewayLegacyStep stage="registration"><EnterCode /></GatewayLegacyStep>} />
        <Route path="/recovery-mail" element={<GatewayLegacyStep stage="registration"><RecoveryMail /></GatewayLegacyStep>} />
        <Route path="/review-info" element={<GatewayLegacyStep stage="registration"><ReviewInfo /></GatewayLegacyStep>} />
        {/* ==================================== */}

        {/* // create account / personal / registration screen ui */}
        <Route path="/register-business" element={<GatewayLegacyStep stage="registration"><RegisterBusiness /></GatewayLegacyStep>} />
        <Route path="/number-of-employee" element={<GatewayLegacyStep stage="registration"><NumberOfEmployee /></GatewayLegacyStep>} />
        <Route path="/contact-info" element={<GatewayLegacyStep stage="registration"><ContactInfo /></GatewayLegacyStep>} />
        <Route path="/domain" element={<GatewayLegacyStep stage="registration"><Domain /></GatewayLegacyStep>} />
        <Route path="/domain-yes" element={<GatewayLegacyStep stage="registration"><DomainYes /></GatewayLegacyStep>} />
        <Route path="/domain-no-find" element={<GatewayLegacyStep stage="registration"><DomainNoFind /></GatewayLegacyStep>} />
        <Route path="/domain-no-available" element={<GatewayLegacyStep stage="registration"><DomainNoAvailable /></GatewayLegacyStep>} />
        <Route path="/business-information" element={<GatewayLegacyStep stage="registration"><BusinessInformation /></GatewayLegacyStep>} />
        <Route
          path="/business-contact-info"
          element={<GatewayLegacyStep stage="registration"><BusinessContactInfo /></GatewayLegacyStep>}
        />
        <Route path="/sign-in-details" element={<GatewayLegacyStep stage="registration"><SingInDetails /></GatewayLegacyStep>} />
        <Route path="/business-enter-code" element={<GatewayLegacyStep stage="registration"><BusinessEnterCode /></GatewayLegacyStep>} />
        <Route path="/captcha-business" element={<GatewayLegacyStep stage="registration"><CaptchaBusiness /></GatewayLegacyStep>} />
        {/* ==================================== */}

        {/* forget mail email / personal / email recovery */}
        <Route path="/forgot-mail-email" element={<GatewayLegacyStep stage="recovery"><ForgotMail_email /></GatewayLegacyStep>} />
        <Route path="/full-name-email" element={<GatewayLegacyStep stage="recovery"><FullName_email /></GatewayLegacyStep>} />
        <Route
          path="/verification-code-email"
          element={<GatewayLegacyStep stage="recovery"><VerificationCode_email /></GatewayLegacyStep>}
        />
        <Route
          path="/enter-code-email"
          element={<GatewayLegacyStep stage="recovery"><EnterCodeEmailRecovery_email /></GatewayLegacyStep>}
        />
        <Route path="/select-account-email" element={<GatewayLegacyStep stage="recovery"><SelectAccount_email /></GatewayLegacyStep>} />
        {/* ==================================== */}

        {/* forget mail phone / personal / email recovery */}
        <Route path="/forgot-mail-phone" element={<GatewayLegacyStep stage="recovery"><ForgotMail_phone /></GatewayLegacyStep>} />
        <Route path="/full-name-phone" element={<GatewayLegacyStep stage="recovery"><FullName_phone /></GatewayLegacyStep>} />
        <Route
          path="/verification-code-phone"
          element={<GatewayLegacyStep stage="recovery"><VerificationCode_phone /></GatewayLegacyStep>}
        />
        <Route
          path="/enter-code-phone"
          element={<GatewayLegacyStep stage="recovery"><EnterCodeEmailRecovery_phone /></GatewayLegacyStep>}
        />
        <Route
          path="/select-account-phone"
          element={<GatewayLegacyStep stage="recovery"><SelectAccountSignIn_phone /></GatewayLegacyStep>}
        />
        {/* ==================================== */}

        {/* forget password mailApp / personal / password recovery */}
        <Route
          path="/forgot-password-mailapp-1"
          element={<GatewayLegacyStep stage="recovery"><ForgotPassword1_mailApp /></GatewayLegacyStep>}
        />
        <Route
          path="/forgot-password-mailapp-2"
          element={<GatewayLegacyStep stage="recovery"><ForgotPassword2_mailApp /></GatewayLegacyStep>}
        />
        {/* ==================================== */}

        {/* forget password phone / personal / password recovery */}
        <Route
          path="/forgot-password-phone-1"
          element={<GatewayLegacyStep stage="recovery"><ForgotPasswordPhone_1 /></GatewayLegacyStep>}
        />
        <Route
          path="/forgot-password-phone-2"
          element={<GatewayLegacyStep stage="recovery"><ForgotPasswordPhone_2 /></GatewayLegacyStep>}
        />
        <Route
          path="/forgot-password-phone-3"
          element={<GatewayLegacyStep stage="recovery"><ForgotPasswordPhone_3 /></GatewayLegacyStep>}
        />
        {/* ==================================== */}

        {/* forget password email / personal / password recovery */}
        <Route
          path="/account-recovery-forgot-password"
          element={<GatewayLegacyStep stage="recovery"><ForgotPasswordEmail_1 /></GatewayLegacyStep>}
        />
        <Route
          path="/enter-code-forgot-password"
          element={<GatewayLegacyStep stage="recovery"><ForgotPasswordEmail_2 /></GatewayLegacyStep>}
        />
         <Route path="/logout" element={<Logout />} />
        {/* ==================================== */}
      </Routes>
    </ThemeProvider>
    </AuthorizationProvider>
    </GatewayStateProvider>
      </AuthMotionScene>
    </MotionProvider>
  );
}

export default App;
